import { Icon } from '@doordash/design-language'
import * as React from 'react'
import * as DA from '../../../typeModules/events'
import { InlineWrapper, ListItem, MenuContainer, TextContainer } from './styles'
import { ItemType } from './types'

export const Menu: React.FC<{
  itemList: ItemType[]
  handleClick: (anchor: string, trackingId: DA.HeaderNames) => void
}> = ({ itemList, handleClick }) => (
  <MenuContainer>
    {itemList.map((item: ItemType) => (
      <ListItem
        key={item.text}
        onClick={() => handleClick(item.anchor, item.trackingId)}
      >
        <InlineWrapper>
          <Icon type={item.icon} />
          <TextContainer>{item.text}</TextContainer>
        </InlineWrapper>
      </ListItem>
    ))}
  </MenuContainer>
)

export default Menu
